import { render, staticRenderFns } from "./theme-base.vue?vue&type=template&id=b98b8592&scoped=true"
import script from "./theme-base.ts?vue&type=script&lang=js&external"
export * from "./theme-base.ts?vue&type=script&lang=js&external"
import style0 from "./theme-base.vue?vue&type=style&index=0&id=b98b8592&prod&lang=scss"
import style1 from "./theme-base.vue?vue&type=style&index=1&id=b98b8592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98b8592",
  null
  
)

export default component.exports